var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21855",
    "data-name": "\\uADF8\\uB8F9 21855",
    transform: "translate(-1296 -672)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28202",
    "data-name": "\\uC0AC\\uAC01\\uD615 28202",
    width: 24,
    height: 24,
    transform: "translate(1296 672)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21850",
    "data-name": "\\uADF8\\uB8F9 21850",
    transform: "translate(-80.957 69.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10302",
    "data-name": "\\uD328\\uC2A4 10302",
    d: "M648.073,18.141l1.651-4.954a.226.226,0,0,1,.055-.088l10.47-10.47h0l1.078-1.078A1.824,1.824,0,0,1,662.665,1a5.248,5.248,0,0,1,2.3.958,4.955,4.955,0,0,1,.9,2.245,1.819,1.819,0,0,1-.551,1.338L664.24,6.62,653.77,17.09a.225.225,0,0,1-.088.055L648.728,18.8A.518.518,0,0,1,648.073,18.141Z",
    transform: "translate(732 605)",
    fill: "#fff",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_73",
    "data-name": "\\uC120 73",
    x2: 2.191,
    y2: 2.191,
    transform: "translate(1393.109 609.673)",
    fill: "#fff",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/Write.f0ad598e5b0a4b5ebab17319cabde345.svg";
export { ForwardRef as ReactComponent };